import React, { CSSProperties } from 'react';
import { useQuery } from 'react-query';

import {
  getOfferListByCriteria,
  getOfferListConfigByPrcodeAndMgid
} from '../../../../services/pricing';
import { Select } from 'antd';
import { SelectProps } from 'antd/lib/select';

export type OfferInputProps = SelectProps<any> & {
  params: UseOfferListParams;
  disabled?: boolean;
  style?: CSSProperties;
  allData?: boolean;
};

const OfferInput = ({ params, allData, ...otherProps }: OfferInputProps) => {
  const { data: offers, isLoading } = useOfferList(params, allData ?? false);

  return (
    <Select
      {...otherProps}
      allowClear
      showSearch
      loading={isLoading}
      optionFilterProp="children"
      filterOption={(input, option) =>
        option?.props.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
      filterSort={(optionA, optionB) =>
        (optionA?.label ?? '')
          .toString()
          .toLowerCase()
          .localeCompare((optionB?.label ?? '').toString().toLowerCase())
      }
    >
      {offers?.map((offer: any) => (
        <Select.Option value={offer.offerid} key={offer.offerid}>
          {offer.offerlabel}
        </Select.Option>
      ))}
    </Select>
  );
};

type UseOfferListParams = {
  mgid?: number;
  prcode?: string;
};

const useOfferList = (params: UseOfferListParams, allData: boolean) => {
  const { mgid, prcode } = params;

  const alldata = allData;

  const getOfferListRequest = useQuery(
    ['offerlistConfigByPrcodeAndMgid', { mgid, prcode }],
    () =>
      getOfferListConfigByPrcodeAndMgid({
        mgid: mgid ?? 0,
        prcode: prcode ?? ''
      }).then((res) => res.list || []),
    { enabled: !alldata }
  );

  const getAllOfferListRequest = useQuery(
    ['getOfferListByCriteria', { mgid, prcode }],
    () =>
      getOfferListByCriteria({
        duration: 0,
        finamount: 0,
        mgid: mgid ?? 0,
        offerid: 0,
        prcode: prcode ?? '',
        status: 'ACTIVE'
      }).then((res) => res.list || []),
    { enabled: alldata }
  );

  return alldata ? getAllOfferListRequest : getOfferListRequest;
};

export default OfferInput;
